
const colorMap = {
  pink:   { accent: "#e91e8c", light: "#fff0f7", icon: "#e91e8c" },
  blue:   { accent: "#0174D0", light: "#eef6ff", icon: "#0174D0" },
  green:  { accent: "#0a9e6e", light: "#edfaf4", icon: "#0a9e6e" },
  red:    { accent: "#e03535", light: "#fff0f0", icon: "#e03535" },
  indigo: { accent: "#4f46e5", light: "#eef0ff", icon: "#4f46e5" },
  purple: { accent: "#7c3aed", light: "#f5f0ff", icon: "#7c3aed" },
  gray:   { accent: "#475569", light: "#f3f5f7", icon: "#475569" },
  teal:   { accent: "#0d9488", light: "#edfafa", icon: "#0d9488" },
  yellow: { accent: "#b45309", light: "#fffbeb", icon: "#b45309" },
};

// Aceita elemento React (react-icons) ou string de classe (legado)
const renderIcon = (icon, style) =>
  typeof icon === "string" ? <i className={icon} style={style} /> : icon;

function CardDashboard({
  id, bgColor, color, user, icon, title, subtitle,
  footerLeftLabel, footerRightLabel, service, footerRightIcon,
  footerLeftIcon, link,
}) {
  const theme = colorMap[color] || colorMap.gray;

  const gerarLogAcesso = () => {
    service
      .gerarLogAcesso({
        usuario: user.sub || "",
        dashboard: title || "",
        tipo: "Acesso",
        descricao: "Acessado o dashboard (" + (title || null) + ")",
        camposAlterados: "Nenhum",
      })
      .then()
      .catch((err) => console.error(err));
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600&family=Sora:wght@600;700&display=swap');

        .card-db {
          font-family: 'DM Sans', sans-serif;
          background: #ffffff;
          border-radius: 14px;
          border: 1px solid #e8ecf1;
          overflow: hidden;
          text-decoration: none !important;
          display: flex;
          flex-direction: column;
          transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
          position: relative;
          cursor: pointer;
        }
        .card-db:hover {
          transform: translateY(-3px);
          box-shadow: 0 12px 32px rgba(0,0,0,0.09), 0 2px 8px rgba(0,0,0,0.05);
        }
        .card-db:hover .card-db-accent {
          opacity: 1;
        }
        .card-db-accent {
          position: absolute;
          top: 0; left: 0; right: 0;
          height: 3px;
          opacity: 0;
          transition: opacity 0.2s ease;
        }
        .card-db-body {
          padding: 20px 22px 16px;
          flex: 1;
          display: flex;
          flex-direction: column;
        }
        .card-db-header {
          display: flex;
          align-items: flex-start;
          gap: 14px;
          margin-bottom: 12px;
        }
        .card-db-icon-wrap {
          width: 46px;
          height: 46px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          font-size: 17px;
        }
        .card-db-title {
          font-family: 'Sora', sans-serif;
          font-size: 14.5px;
          font-weight: 600;
          color: #000;
          line-height: 1.35;
          margin: 0;
          padding-top: 2px;
        }
        .card-db-subtitle {
          font-size: 12.5px;
          color: #000;
          line-height: 1.55;
          flex: 1;
          margin-bottom: 16px;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        .card-db-footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 11px 22px;
          background: #f8fafc;
          border-top: 1px solid #f0f4f8;
          font-size: 11.5px;
          color: #8b929c;
          font-weight: 500;
        }
        .card-db-footer span {
          display: flex;
          align-items: center;
          gap: 5px;
        }
        .card-db-badge {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          font-size: 10.5px;
          font-weight: 600;
          letter-spacing: 0.04em;
          text-transform: uppercase;
          padding: 2px 8px;
          border-radius: 20px;
        }
        @keyframes cardIn {
          from { opacity: 0; transform: translateY(14px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .card-db { animation: cardIn 0.35s ease both; }
      `}</style>

      <a
        href={link}
        id={id}
        className="card-db"
        onClick={gerarLogAcesso}
      >
        {/* Top accent line */}
        <div
          className="card-db-accent"
          style={{ background: `linear-gradient(90deg, ${theme.accent}, ${theme.accent}99)` }}
        />

        <div className="card-db-body">
          <div className="card-db-header">
            <div
              className="card-db-icon-wrap"
              style={{ background: theme.light, color: theme.icon }}
            >
              {renderIcon(icon)}
            </div>
            <h3 className="card-db-title">{title}</h3>
          </div>
          <p className="card-db-subtitle">{subtitle}</p>
        </div>

        <div className="card-db-footer">
          <span>
            <span style={{ color: theme.accent, display: "flex" }}>{renderIcon(footerRightIcon)}</span>
            {footerLeftLabel}
          </span>
          <span>
            {renderIcon(footerLeftIcon)}
            {footerRightLabel}
          </span>
        </div>
      </a>
    </>
  );
}

export default CardDashboard;